import { Grid } from "@mui/material";
import ByzCard from "src/components/core-components/ByzCard";
import ByzTitleBox from "src/components/core-components/ByzTitleBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMcParameterDetailRadio from "src/components/shared-components/ByzMcParameterDetailRadio";

interface DasScaleProps {
  t: (key: string) => string;
  cardData: any;
  selectedMCPs: Record<string, any>;
  handleMCPChange: (key: string, value: any) => void;
  getMCPParameterDetails: (id: number) => any;
  mcpCacheLoaded: boolean;
}

const DasScale: React.FC<DasScaleProps> = ({
  t,
  cardData,
  selectedMCPs,
  handleMCPChange,
  getMCPParameterDetails,
  mcpCacheLoaded,
}) => {
  return (
    <ByzCard sx={{ mt: 3, mb: 5 }}>
      <ByzTitleBox title={t("pain-assessment-scale.das-scale.title")} />

      <ByzCard sx={{ padding: 0, ml: 1, mb: 1 }}>
        {/* 1. Grup - Yüz İfadesi & Ağlama */}
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.das-scale.das-face-expression")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.DAS_FACE_EXPRESSION.mcpId}
              value={selectedMCPs.DAS_FACE_EXPRESSION}
              handleChange={(val) =>
                val && handleMCPChange("DAS_FACE_EXPRESSION", val)
              }
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.DAS_FACE_EXPRESSION.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.das-scale.das-upper-extremity-mov")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.DAS_UPPER_EXTREMITY_MOV.mcpId}
              value={selectedMCPs.DAS_UPPER_EXTREMITY_MOV}
              handleChange={(val) => val && handleMCPChange("DAS_UPPER_EXTREMITY_MOV", val)}
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.DAS_UPPER_EXTREMITY_MOV.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <ByzMuiTypography sx={{ marginLeft: "0px" }}>
              {t("pain-assessment-scale.das-scale.das-adaptation-ven")}
            </ByzMuiTypography>
            <ByzMcParameterDetailRadio
              sx={{ marginLeft: "20px" }}
              mcpId={cardData.mcpConfig.DAS_ADAPTATION_VEN.mcpId}
              value={selectedMCPs.DAS_ADAPTATION_VEN}
              handleChange={(val) => val && handleMCPChange("DAS_ADAPTATION_VEN", val)}
              cachedData={getMCPParameterDetails(
                cardData.mcpConfig.DAS_ADAPTATION_VEN.mcpId
              )}
              cacheLoaded={mcpCacheLoaded}
            />
          </Grid>
        </Grid>
      </ByzCard>

      {/* Skor Bilgisi */}
      <ByzCard sx={{ padding: 0, ml: 1, mt: 0 }}>
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>
              {
                "3- Ağrı yok, 4-6 Hafif Ağrı, 7-9 Orta Şiddetli Ağrı, 10-12 Şiddetli Ağrı "
              }
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>Skor : 1</ByzMuiTypography>
          </Grid>
        </Grid>
      </ByzCard>
    </ByzCard>
  );
};

export default DasScale;
